import React from 'react';
import { motion } from 'framer-motion';

export const TransformationNarrative = () => {
  return (
    <section className="py-32 md:py-40 px-6 bg-[#fdfbf7]">
      <div className="max-w-3xl mx-auto text-center">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
        >
          <div className="mb-12">
            <span className="inline-block bg-[#704229] text-white px-8 py-3 text-sm font-medium tracking-widest uppercase">
              The Transformation
            </span>
          </div>
          
          <h2 className="text-5xl md:text-6xl lg:text-7xl font-normal text-[#1a1a1a] mb-12 leading-tight" style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 500 }}>
            This isn't self-help.<br />This is self-mastery.
          </h2>
          
          <div className="space-y-8 text-lg md:text-xl text-[#5a5a5a] leading-loose font-light">
            <p>
              You don't need more information. You don't need another course, another book, another quick fix. 
              What you need is to understand the patterns running your life—and learn how to rewrite them.
            </p>
            <p>
              This is about going deep. Releasing what no longer serves you. Healing the parts of you that have been 
              holding you back. And finally stepping into the unstoppable version of yourself that's been waiting.
            </p>
            <p className="text-2xl md:text-3xl font-normal text-[#2a2a2a] pt-8" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
              It's not about becoming someone new.<br />
              It's about becoming fully you.
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
